export enum PRODUCT_TITLE_METRIC_ENUM {
  SEO_STATUS_SUMMARY = 'seo-status-summary',
  SEO_KPIS = 'seo-kpis',
  SEO_ISSUES_RANKING = 'seo-issues-ranking',
  SEO_SCORE_DISTRIBUTION = 'seo-score-distribution',
  SEO_ACTIVE_GATES = 'seo-active-gates',
}
